exports["DK"] = require("./DK.js");
exports["CH"] = require("./CH.js");